import { formatNumber, roundToNearestIncrement } from 'helpers/formatting';
import { findAttributeValues } from 'helpers/findAttributeValues';

import { Currency } from 'types';
import type { SectionView, IAdAttributeView } from 'types';
import { FinanceInfo } from 'components/PageWrappers/AdDetails/types';
import { formatSearchTerms } from 'helpers/formatSearchTerms';

export const generateSaveSearchModalData = (
  displayAttributes: IAdAttributeView[],
  price: string | null,
  currency: Currency,
  section?: SectionView,
  county?: string,
  wanted?: boolean,
) => {
  const {
    make = 'n/a',
    model = 'n/a',
    year,
    transmission = 'n/a',
    bodyType = 'n/a',
  } = findAttributeValues(displayAttributes, [
    'make',
    'model',
    'year',
    'transmission',
    'bodyType',
  ]);

  const formattedYear = year
    ? `${parseInt(year) - 1} - ${parseInt(year) + 1}`
    : 'n/a';

  const priceAsNumber = price ? parseInt(price.replace(/,/g, '')) : 0;
  const chosenCurrency = currency === 'GBP' ? '£' : '€';

  const formattedPrice =
    priceAsNumber > 1
      ? `${chosenCurrency}${formatNumber(
          roundToNearestIncrement(priceAsNumber * 0.85, 100),
        )} - ${chosenCurrency}${formatNumber(
          roundToNearestIncrement(priceAsNumber * 1.15, 100),
        )}`
      : 'n/a';

  const offerType = wanted ? 'wanted' : 'forsale';

  const name = `${make || 'unknown make'} ${model || 'unknown model'} in ${
    section?.displayName || 'unknown section'
  }`;

  const terms = formatSearchTerms([
    section?.displayName || 'n/a',
    `${make} ${model}`,
    formattedYear,
    formattedPrice,
    offerType,
    county || 'n/a',
    transmission,
    bodyType,
  ]);

  return {
    name,
    terms,
    section: section?.name || 'n/a',
  };
};

interface FinanceInfoLink
  extends Omit<FinanceInfo, 'partnerName' | 'partnerType'> {}

export const generateFinanceLink = (financeInfo: FinanceInfoLink) => {
  return financeInfo?.internalRedirectURL
    ? `https://www.donedeal.ie${financeInfo?.internalRedirectURL}`
    : financeInfo?.externalRedirectURL
    ? financeInfo?.externalRedirectURL
    : '';
};
